import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface KnowledgeBaseHeaderProps {
  name: string;
  description: string;
  actions: React.ReactNode;
  collapsed?: boolean;
  onToggleCollapse?: () => void;
}

const KnowledgeBaseHeader = ({
  name,
  description,
  actions,
  collapsed = false,
  onToggleCollapse,
}: KnowledgeBaseHeaderProps) => {
  return (
    <div className="rounded-lg bg-card p-4 shadow-sm">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h2 className="text-xl font-bold">{name}</h2>
          {!collapsed && <p className="text-sm text-muted-foreground">{description}</p>}
        </div>

        {onToggleCollapse && (
          <Button
            type="button"
            size="sm"
            variant="outline"
            onClick={onToggleCollapse}
            className="shrink-0"
            aria-label={collapsed ? 'Expand knowledge base header' : 'Collapse knowledge base header'}
            title={collapsed ? '' : ''}
          >
            {collapsed ? <ChevronDown className="mr-2 h-4 w-4" /> : <ChevronUp className="mr-2 h-4 w-4" />}
            {collapsed ? '' : ''}
          </Button>
        )}
      </div>

      {!collapsed && <div className="mt-4">{actions}</div>}
    </div>
  );
};

export default KnowledgeBaseHeader;
